module.exports = __webpack_public_path__ + "img/Feature.7ee61cdc.jpg";